<script>
	import {getCookie} from "@/util/util"
	import ajax from '@/api/ajax'
	import loginType from "@/constant/loginType"
	import {urls} from '@/constant/paths'
	import {jump} from '@/mixins/pageJump/'

	const urlConfig = {
		owfUrl:`/mobile/cn/sc/login`,
		cxUrl:`${urls.CX_CHECK_TICKET}?type=${loginType.WX_MYSF}`
	};

	export default {
		beforeCreate() {
			if (!getCookie('loginUser')) {
				return location.replace(urlConfig.owfUrl);
			}

			// 灰度用户获取ticket
			ajax.getTicket({
				params: {ts: new Date().getTime()}
			}).then(res => {
				if (res.data.code === 0) {
					let ticket = res.data.result;
					location.replace(`${urlConfig.cxUrl}&ticket=${ticket}`)
				}else if(res.data.code === 121){
					location.replace(urlConfig.owfUrl);
				}
			})
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/user/index.vue